import * as React from 'react';
import { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import { ButtonWidget } from '../../../widgets/controls/ButtonWidget';
import { useSystem } from '../../../hooks/useSystem';
import { GroupModel } from '../../../core/models/GroupModel';
import { ResourcePageHeaderWidget } from '../../../widgets/pages/ResourcePageHeaderWidget';

export interface PackHeaderWidgetProps {
  group: GroupModel;
}

export const GroupJoinButtonWidget: React.FC<PackHeaderWidgetProps> = observer((props) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const system = useSystem();

  useEffect(() => {
    props.group.loadMyRelation();
  }, []);

  const { group } = props;
  if (group.my_status_loading) {
    return null;
  }
  if (!group.my_status) {
    return (
      <ButtonWidget
        loading={loading}
        label="Join"
        action={() => {
          setLoading(true);
          group.join().finally(() => {
            setLoading(false);
          });
        }}
      />
    );
  }
  return (
    <ButtonWidget
      loading={loading}
      label="Leave"
      action={async () => {
        let confirm = await system.dialog_store.showConfirmDialog({
          title: 'Leave group?',
          desc: 'Are you sure you wish to leave?'
        });
        if (!confirm) {
          return;
        }

        setLoading(true);
        group.leave().finally(() => {
          setLoading(false);
          navigate(system.user.link, { state: 'push' });
        });
      }}
    />
  );
});

export const GroupHeaderWidget: React.FC<PackHeaderWidgetProps> = observer((props) => {
  const { group } = props;
  return (
    <ResourcePageHeaderWidget
      hero_image={group.headerImage}
      label={group.data?.name}
      primary_image={group.image}
      primaryAction={<GroupJoinButtonWidget group={group} />}
      meta={[]}
    />
  );
});
